import { useEffect, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { MdOutlineVideocam } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

import { Button, Layout, Text } from '../../components'
import {
  ERROR_TYPE,
  PATH,
  Requirement,
  SKIP_REQUIREMENT_DEVICES,
} from '../../constants'
import {
  useContactProvider,
  useDeviceIdProvider,
  useOnline,
  useRedialApi,
  useSavedIdentifier,
} from '../../hooks'
export function TopFrame() {
  const navigate = useNavigate()
  const { getRoute, deviceId } = useDeviceIdProvider()
  const { data: redialData } = useRedialApi(deviceId)
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'frames.TopFrame')
  const en = i18n.getFixedT('en', 'translation', 'frames.TopFrame')
  const { setRequirement } = useContactProvider()
  const isOnline = useOnline()
  useSavedIdentifier()

  useEffect(() => {
    if (!isOnline) {
      navigate(getRoute(PATH.maintenance), {
        state: {
          error: ERROR_TYPE.OFFLINE,
        },
      })
    }
  }, [isOnline, navigate, getRoute])

  useEffect(() => {
    if (
      redialData?.call_type === 'redial_from_reception' &&
      redialData.receiver_status === null
    ) {
      navigate(getRoute(PATH.callback))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redialData])

  const isSkipRequirement = useMemo(() => {
    return SKIP_REQUIREMENT_DEVICES.includes(deviceId ?? '')
  }, [deviceId])

  return (
    <Layout>
      <div className="wide:mt-[20px] wide:gap-y-[30px] mt-[60px] flex w-full flex-col items-center gap-y-[80px]">
        <Text size="heading3" align="center">
          {ja('information')}
          <br />
          {en('information')}
        </Text>
        <div className="flex gap-x-[120px]">
          <Button
            className="h-[250px] w-[400px]"
            size="l"
            square
            fill
            onClick={() => {
              if (isSkipRequirement) {
                setRequirement(Requirement.Other)
                navigate(getRoute(PATH.selectLanguage))
                return
              }

              navigate(getRoute(PATH.requirement))
            }}
          >
            <div className="flex flex-col items-center justify-center gap-3">
              <Text size="lg4" align="center">
                {ja('proceed')}
                <br />
                {en('proceed')}
              </Text>
              <MdOutlineVideocam size={75} />
            </div>
          </Button>
        </div>
      </div>
    </Layout>
  )
}
